import React from 'react';
import TextField from '@material-ui/core/TextField';
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';
const currencies = [
    {value: 0,label: <IntlMessages id="Choose"/>,},
    {value: "Aktiv",label:<IntlMessages id="Table.active"/>,},
    {value: "Förfallen",label: <IntlMessages id="userProfile.Mail.notification.duedate" /> },
    {value: "Makulerad",label:<IntlMessages id="Invoice.Status.Shredded" />,},
    {value: "Ej bokförd",label:<IntlMessages id="Invoice.Status.Not.Recorded" />,},
    {value: "Obetald",label:<IntlMessages id="Invoice.Status.Unpaid" />,},
    {value: "Slutbetald",label:<IntlMessages id="Invoice.Status.paid" />,},
];

function SelectAvtalInvoiceStatus(props) {
    const handleChange = (event) => {
        props.onChangeHandle("Fakturastatus",event.target.value)
    };
    return (
        <div>
             <TextField
              variant="outlined"
              fullWidth
              label={<IntlMessages id="Input.invoice.Status" />}
              size="small"
              name="Fakturastatus"
              select
              value={0}
              SelectProps={{native: true,}}
              InputLabelProps={{shrink: true,}}
              onChange={handleChange}
            >
          {
          currencies.map((option) => (
            <option value={option.value}>
              {option.label}
            </option>
          ))}
            </TextField>  
        </div>
    );
}

export default SelectAvtalInvoiceStatus;